function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M111.297 16.41c.3 3.576-1.426 9.286-.734 13.618.77 4.818 3.222 6.81 5.297 7.625l-.003-.003-.77 2.667-.745 4.377 8.184 2.437 6.61-1.41-.435-7.6s6.016-3.07 6.684-10.891c1.875.343 3.962-1.286 4.788-3.822.878-2.694.003-5.394-1.958-6.029-1.962-.635-4.3.635-5.642 2.933l-4.507-12.235-12.876 1.044-3.893 7.288z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB27D",
  d: "m111.236 15.983 11.359-4.809 6.956-.373 2.492 7.246 4.332-1 4.14.506v2.958l-.502 3.758-2.123 2.172-2.505.789-.057 1.767-1.528 3.679-2.753 3.488-2.346 2.044.434 7.417-3.26 2.261-9.412-4.011-1.375-3.555.77-2.112-1.894-1.563-2.076-2.692-1.49-5.515 1.49-10.391z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.46 20.511c-.209-1.515-1.011-2.732-2.245-3.129-1.962-.635-4.3.635-5.642 2.933 0 0-4.528-2.727-5.432-9.893 0 0-7.864 6.754-15.841 5.987-6.283-.605-6.708-12.377-6.708-12.377s10.508-7.103 22.291-2.446c0 0 5.603-2.438 11.565 3.302 6.732 6.48 2.013 15.623 2.013 15.623z",
  fill: "#1E1E1E",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.297 16.41c.3 3.576-1.426 9.286-.734 13.618 1.41 8.84 8.493 8.168 8.493 8.168M135.385 27.23c-.67 7.822-6.684 10.892-6.684 10.892",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.777 26.31c.344.386.766.672 1.258.83 1.961.636 4.26-1.035 5.141-3.732.878-2.694.003-5.394-1.958-6.029-1.962-.635-4.3.635-5.642 2.933 0 0-4.528-2.727-5.432-9.893 0 0-7.864 6.754-15.841 5.987-6.283-.605-6.708-12.377-6.708-12.377s10.508-7.103 22.291-2.446c0 0 5.603-2.438 11.565 3.302 6.738 6.483 2.016 15.63 2.016 15.63",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.328 20.303c1.749-.82 2.743.838 2.13 2.32M128.857 40.86l.278 4.863M115.858 37.653l-.77 2.667",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.03 195.501s65.88-15.435 65.88-74.981V51.567a131.344 131.344 0 0 1-64.77-23.129A131.334 131.334 0 0 1 27.15 53.14v67.377c0 59.552 65.88 74.984 65.88 74.984z",
  fill: "#2B9D8B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.123 65.284v54.257c0 19.496 8.902 35.49 26.46 47.536 9.498 6.518 19.078 10.188 24.447 11.915 5.5-1.77 15.323-5.543 24.995-12.294 17.195-12.005 25.912-27.87 25.912-47.157V63.71a145.854 145.854 0 0 1-49.61-18.383c-16.045 10-33.584 16.707-52.204 19.958z",
  fill: "#E0F4E9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E15D29",
  fillRule: "nonzero",
  d: "m86.059 140.266-26.712-26.608 10.164-10.125 16.548 16.483 36.48-36.343L132.701 93.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.79 124.857c.078-1.42.12-2.864.12-4.337V51.567M27.15 95.49v23.95M27.15 53.142v10.102M76.177 39.408A131.364 131.364 0 0 1 27.15 53.142M94.14 28.438a131.513 131.513 0 0 1-7.336 4.961",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.043 46.615a131.465 131.465 0 0 1-37.905-18.177",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m88.523 38.06-2.144-5.54c-.317-.821-1.267-1.197-2.063-.821a1.505 1.505 0 0 0-.725 1.993l.018.074a1.712 1.712 0 0 0-2.234-.611 1.7 1.7 0 0 0-.751 2.264l-.018-.021a1.545 1.545 0 0 0-2.186-.546 1.53 1.53 0 0 0-.47 2.106l.09.14a1.448 1.448 0 0 0-2.172-.325 1.435 1.435 0 0 0-.2 1.963l3 3.914a1.215 1.215 0 0 0 1.994-1.378l.399.635c.392.627 1.21.836 1.856.475a1.381 1.381 0 0 0 .536-1.88l.557 1c.408.73 1.348.966 2.055.516.61-.39.838-1.17.536-1.823l-.515-1.11a1.327 1.327 0 0 0 1.904.567 1.31 1.31 0 0 0 .533-1.593z",
  fill: "#FFB27D",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.208 42.25a1.45 1.45 0 0 1-1.2-.742l-3.346-6.006a1.702 1.702 0 0 1 .713-2.344h0a1.714 1.714 0 0 1 2.339.802l2.518 5.448",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.606 35.398a1.545 1.545 0 0 0-2.186-.546h0a1.53 1.53 0 0 0-.47 2.106M76.79 40.207l-1.125-1.468a1.438 1.438 0 0 1 .2-1.963h0c.67-.578 1.701-.423 2.171.325l2.156 3.431M83.591 33.695a1.505 1.505 0 0 1 .725-1.993h0c.796-.38 1.746 0 2.063.82l.925 2.396",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M146.195 47.265a1.443 1.443 0 0 0-1.943 1.015l.036-.161a1.537 1.537 0 0 0-1.138-1.838 1.541 1.541 0 0 0-1.887 1.23l-.009.026a1.712 1.712 0 0 0-3.369-.576l-.006-.086a1.507 1.507 0 0 0-1.341-1.647 1.51 1.51 0 0 0-1.68 1.447l-.204 5.93a1.325 1.325 0 0 0 2.644.176l-.12 1.218a1.447 1.447 0 0 0 1.106 1.548 1.453 1.453 0 0 0 1.772-1.157l.198-1.128a1.389 1.389 0 0 0 2.722.549l.168-.731c-.15.647.254 1.295.904 1.447a1.217 1.217 0 0 0 1.432-.797l1.55-4.678a1.443 1.443 0 0 0-.835-1.787z",
  fill: "#FFB27D",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "m140.251 53.265.991-5.639a1.708 1.708 0 0 0-1.443-1.983h0a1.712 1.712 0 0 0-1.947 1.521l-.598 6.074M141.263 47.51a1.543 1.543 0 0 1 1.887-1.229h0c.82.2 1.326 1.017 1.138 1.838l-1.312 5.692M146.3 51.254l.73-2.199a1.435 1.435 0 0 0-.835-1.787h0a1.443 1.443 0 0 0-1.943 1.015",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.882 46.872a1.507 1.507 0 0 0-1.341-1.647h0a1.51 1.51 0 0 0-1.68 1.447",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  d: "M42.123 65.284v54.257c0 19.496 8.902 35.49 26.46 47.536 9.498 6.518 19.078 10.188 24.447 11.915m50.907-98.773v-16.51a145.854 145.854 0 0 1-49.61-18.383M93.03 178.995a98.951 98.951 0 0 0 15.724-6.65M132.702 93.799l-46.643 46.467-16.285-16.223",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.348 182.482c15.314 9.651 29.682 13.02 29.682 13.02s46.011-10.78 61.128-49.076M47.435 169.854a85.734 85.734 0 0 0 9.505 8.23M66.588 120.872l-4.546-4.529",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeWidth: 1.291,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M149 195.501H37"
}));

function SvgDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 196,
    viewBox: "0 0 185 196",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.1b1254fa.svg";
export { ForwardRef as ReactComponent };